import { useApi, useSavings } from '@/api';
import {
  ActivityCard,
  EntityName,
  KpiCard,
  Link,
  Page,
  PageSkeleton
} from '@/components';
import { useSearchParams } from '@/hooks';
import { tokensMapping } from '@/utils/tokens';
import {
  CryptoIcon,
  EtherScanPictogram,
  Flex,
  Heading,
  LinkWrapper
} from '@blockanalitica/ui';
import HistoricTabs from './HistoricTabs';
import HoldersDonutChart from './HoldersDonutChart';
import TopDepositors from './TopDepositors';

export default function DSRPage() {
  const [daysAgo] = useSearchParams('days_ago', '1');
  const [data, error] = useApi({
    url: '/save/dsr/',
    queryParams: {
      days_ago: daysAgo
    }
  });

  const [savings, savingsError] = useSavings(daysAgo);

  if (error) {
    throw error;
  }
  if (savingsError) {
    throw savingsError;
  }

  if (data && savings) {
    return (
      <Page
        title={
          <EntityName
            symbol1={
              <CryptoIcon
                name={'DAI'}
                address={tokensMapping('DAI').address}
                size="4"
              />
            }>
            <Heading size="1">
              <Flex gap="xs">
                DAI Savings Rate
                <a
                  href={`https://etherscan.io/address/0x197E90f9FAD81970bA7976f33CbD77088E5D7cf7`}
                  target="_blank"
                  rel="noreferrer">
                  <EtherScanPictogram size="0" />
                </a>
              </Flex>
            </Heading>
          </EntityName>
        }>
        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <KpiCard
            variant="dai"
            title="Total Supply"
            data={savings}
            field="total_dsr"
            options={{
              currency: tokensMapping('DAI'),
              notation: 'standard',
              valueOptions: { currencyValueOptions: { iconSize: '3' } }
            }}
          />
          <KpiCard
            title="Savings rate"
            data={data}
            field="rate"
            options={{
              percentage: true,
              variants: { valuePercentageValue: 'dynamic' }
            }}
          />
        </Flex>

        <HistoricTabs />
        <ActivityCard url={'/save/dsr/activity/'} linkTo={'activity'} />
        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <Flex gap={['m', 's']} flexDirection="column" width="100%">
            <LinkWrapper
              to="suppliers"
              // @ts-ignore
              as={Link}
              variant="kpiCardLinkWithBlendMode">
              <KpiCard
                title="N° of Suppliers"
                data={data}
                field="depositors"
                options={{
                  linkArrow: true,
                  variants: { valuePercentageValue: 'dynamic' }
                }}
              />
            </LinkWrapper>

            <TopDepositors flexBasis="100%" />
          </Flex>

          <Flex flexBasis="100%" flexDirection="column" alignItems="center">
            <Heading size="3">Suppliers Distribution</Heading>
            <HoldersDonutChart />
          </Flex>
        </Flex>
      </Page>
    );
  }
  return <PageSkeleton />;
}
